class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
            (this.debouncedOnSubmit = debounce((e) => {
                this.onSubmitHandler(e);
            }, 800));
        this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
        const e = this.querySelector("#FacetsWrapperDesktop");
        e && e.addEventListener("keyup", onKeyUpEscape);
    }
    static setListeners() {
        window.addEventListener("popstate", (e) => {
            const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1);
        });
    }
    static toggleActiveFacets(e = !0) {
        document.querySelectorAll(".js-facet-remove").forEach((t) => {
            t.classList.toggle("disabled", e);
        });
    }
    static renderPage(e, t, r = !0) {
        FacetFiltersForm.searchParamsPrev = e;

        const o = FacetFiltersForm.getSections(),
            i = document.getElementById("ProductCount"),
            a = document.getElementById("ProductCountDesktop");

        document
            .querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner")
            .forEach((e) => e.classList.remove("hidden"));

        document.getElementById("ProductGridContainer")
            .querySelector(".collection")
            .classList.add("loading");

        i && i.classList.add("loading");
        a && a.classList.add("loading");

        /* 🔥 ADD THIS BLOCK ONLY */
        const currentParams = new URLSearchParams(window.location.search);
        const currentView = currentParams.get("view");

        let updatedParams = e;

        if (currentView && !updatedParams.includes("view=")) {
            updatedParams += `&view=${currentView}`;
        }
        /* 🔥 END BLOCK */

        o.forEach((r) => {
            const o = `${window.location.pathname}?section_id=${r.section}&${updatedParams}`,
                i = (e) => e.url === o;

            FacetFiltersForm.filterData.some(i)
                ? FacetFiltersForm.renderSectionFromCache(i, t)
                : FacetFiltersForm.renderSectionFromFetch(o, t);
        });

        // r && FacetFiltersForm.updateURLHash(updatedParams);
        // if (r) {
        //     window.location.href = `${window.location.pathname}?${updatedParams}`;
            
        // }
        if (r) {
            window.location.href = `${window.location.pathname}?${updatedParams}#product-list-section`;
        }
    }
    static renderSectionFromFetch(e, t) {
        fetch(e)
            .then((e) => e.text())
            .then((r) => {
                const o = r;
                (FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: o, url: e }]),
                    FacetFiltersForm.renderFilters(o, t),
                    FacetFiltersForm.renderProductGridContainer(o),
                    FacetFiltersForm.renderProductCount(o),
                    "function" == typeof initializeScrollAnimationTrigger &&
                        initializeScrollAnimationTrigger(o.innerHTML);
            });
    }
    static renderSectionFromCache(e, t) {
        const r = FacetFiltersForm.filterData.find(e).html;
        FacetFiltersForm.renderFilters(r, t),
            FacetFiltersForm.renderProductGridContainer(r),
            FacetFiltersForm.renderProductCount(r),
            "function" == typeof initializeScrollAnimationTrigger && initializeScrollAnimationTrigger(r.innerHTML);
    }
    static renderProductGridContainer(e) {
        (document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
            .parseFromString(e, "text/html")
            .getElementById("ProductGridContainer").innerHTML),
            document
                .getElementById("ProductGridContainer")
                .querySelectorAll(".scroll-trigger")
                .forEach((e) => {
                    e.classList.add("scroll-trigger--cancel");
                });
    }
    static renderProductCount(e) {
        const t = new DOMParser().parseFromString(e, "text/html").getElementById("ProductCount").innerHTML,
            r = document.getElementById("ProductCount"),
            o = document.getElementById("ProductCountDesktop");
        (r.innerHTML = t), r.classList.remove("loading"), o && ((o.innerHTML = t), o.classList.remove("loading"));
        document
            .querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner")
            .forEach((e) => e.classList.add("hidden"));
    }
    static renderFilters(e, t) {
        const r = new DOMParser().parseFromString(e, "text/html"),
            o = r.querySelectorAll(
                "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
            ),
            i = document.querySelectorAll(
                "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
            );
        Array.from(i).forEach((e) => {
            Array.from(o).some(({ id: t }) => e.id === t) || e.remove();
        });
        const a = (e) => {
                const r = t ? t.target.closest(".js-filter") : void 0;
                return !!r && e.id === r.id;
            },
            n = Array.from(o).filter((e) => !a(e)),
            s = Array.from(o).find(a);
        if (
            (n.forEach((e, t) => {
                if (document.getElementById(e.id)) document.getElementById(e.id).innerHTML = e.innerHTML;
                else {
                    if (t > 0) {
                        const { className: r, id: o } = n[t - 1];
                        if (e.className === r) return void document.getElementById(o).after(e);
                    }
                    e.parentElement && document.querySelector(`#${e.parentElement.id} .js-filter`).before(e);
                }
            }),
            FacetFiltersForm.renderActiveFacets(r),
            FacetFiltersForm.renderAdditionalElements(r),
            s)
        ) {
            const e = t.target.closest(".js-filter").id;
            if (e) {
                FacetFiltersForm.renderCounts(s, t.target.closest(".js-filter")),
                    FacetFiltersForm.renderMobileCounts(s, document.getElementById(e));
                const r = document.getElementById(e),
                    o = r.classList.contains("mobile-facets__details")
                        ? ".mobile-facets__close-button"
                        : ".facets__summary",
                    i = r.querySelector(o),
                    a = "text" === t.target.getAttribute("type");
                i && !a && i.focus();
            }
        }
    }
    static renderActiveFacets(e) {
        [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
            const r = e.querySelector(t);
            r && (document.querySelector(t).innerHTML = r.innerHTML);
        }),
            FacetFiltersForm.toggleActiveFacets(!1);
    }
    static renderAdditionalElements(e) {
        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
            if (!e.querySelector(t)) return;
            const r = document.querySelector(t);
            r && (r.innerHTML = e.querySelector(t).innerHTML);
        });
        const t = document.getElementById("FacetFiltersFormMobile");
        if (t) {
            const e = t.closest("menu-drawer");
            e && "function" == typeof e.bindEvents && e.bindEvents();
        }
    }
    static renderCounts(e, t) {
        const r = t.querySelector(".facets__summary"),
            o = e.querySelector(".facets__summary");
        o && r && (r.outerHTML = o.outerHTML);
        const i = t.querySelector(".facets__header"),
            a = e.querySelector(".facets__header");
        a && i && (i.outerHTML = a.outerHTML);
        const n = t.querySelector(".facets-wrap"),
            s = e.querySelector(".facets-wrap");
        if (s && n) {
            Boolean(t.querySelector("show-more-button .label-show-more.hidden")) &&
                s
                    .querySelectorAll(".facets__item.hidden")
                    .forEach((e) => e.classList.replace("hidden", "show-more-item")),
                (n.outerHTML = s.outerHTML);
        }
    }
    static renderMobileCounts(e, t) {
        const r = t.querySelector(".mobile-facets__list"),
            o = e.querySelector(".mobile-facets__list");
        o && r && (r.outerHTML = o.outerHTML);
    }
    static updateURLHash(e) {
        history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
    }
    static getSections() {
        return [{ section: document.getElementById("product-grid").dataset.id }];
    }
    createSearchParams(e) {
        const t = new FormData(e);
        return new URLSearchParams(t).toString();
    }
    onSubmitForm(e, t) {
        FacetFiltersForm.renderPage(e, t);
    }
    onSubmitHandler(e) {
        e.preventDefault();
        const t = document.querySelectorAll("facet-filters-form form");
        if ("mobile-facets__checkbox" == e.srcElement.className) {
            const t = this.createSearchParams(e.target.closest("form"));
            this.onSubmitForm(t, e);
        } else {
            const r = [],
                o = "FacetFiltersFormMobile" === e.target.closest("form").id;
            t.forEach((e) => {
                o
                    ? "FacetFiltersFormMobile" === e.id && r.push(this.createSearchParams(e))
                    : ("FacetSortForm" !== e.id && "FacetFiltersForm" !== e.id && "FacetSortDrawerForm" !== e.id) ||
                      r.push(this.createSearchParams(e));
            }),
                this.onSubmitForm(r.join("&"), e);
        }
    }
    onActiveFilterClick(e) {
        e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
        const t =
            -1 == e.currentTarget.href.indexOf("?")
                ? ""
                : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(t);
    }
}
(FacetFiltersForm.filterData = []),
    (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
    (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
    customElements.define("facet-filters-form", FacetFiltersForm),
    FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
    constructor() {
        super(),
            this.querySelectorAll("input").forEach((e) => {
                e.addEventListener("change", this.onRangeChange.bind(this)),
                    e.addEventListener("keydown", this.onKeyDown.bind(this));
            }),
            this.setMinAndMaxValues();
    }
    onRangeChange(e) {
        this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
    }
    onKeyDown(e) {
        if (e.metaKey) return;
        e.key.match(/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/) ||
            e.preventDefault();
    }
    setMinAndMaxValues() {
        const e = this.querySelectorAll("input"),
            t = e[0],
            r = e[1];
        r.value && t.setAttribute("data-max", r.value),
            t.value && r.setAttribute("data-min", t.value),
            "" === t.value && r.setAttribute("data-min", 0),
            "" === r.value && t.setAttribute("data-max", r.getAttribute("data-max"));
    }
    adjustToValidValues(e) {
        const t = Number(e.value),
            r = Number(e.getAttribute("data-min")),
            o = Number(e.getAttribute("data-max"));
        t < r && (e.value = r), t > o && (e.value = o);
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("a");
        e.setAttribute("role", "button"),
            e.addEventListener("click", this.closeFilter.bind(this)),
            e.addEventListener("keyup", (e) => {
                e.preventDefault(), "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
            });
    }
    closeFilter(e) {
        e.preventDefault();
        (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e);
    }
}
customElements.define("facet-remove", FacetRemove);
